import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Typography$1 from '../../basics/Typography/Typography.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import Tags$1 from '../Tags/Tags.js';
import StyledTagTeaser from './TagTeaser.style.js';

const TagTeaser = ({
  className,
  headline,
  teasers
}) => /*#__PURE__*/React$1.createElement(StyledTagTeaser, {
  className: className
}, headline && /*#__PURE__*/React$1.createElement("div", {
  className: "tagTeaser__headline"
}, /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
  as: "h2",
  variant: "subline",
  text: headline
}), /*#__PURE__*/React$1.createElement("div", {
  className: "tagTeaser__line"
})), /*#__PURE__*/React$1.createElement("div", {
  className: "tagTeaser__container"
}, teasers.map(({
  headline: title,
  tags
}) => /*#__PURE__*/React$1.createElement("div", {
  key: title,
  className: "tagTeaser__teaser"
}, /*#__PURE__*/React$1.createElement(Typography$1, {
  variant: "copyIntro"
}, title), /*#__PURE__*/React$1.createElement(Tags$1, {
  className: "tagTeaser__tags",
  horizontal: true,
  tags: tags,
  variant: "small"
})))));

TagTeaser.propTypes = {
  className: PropTypes$1.string,
  headline: PropTypes$1.string,
  teasers: PropTypes$1.arrayOf(PropTypes$1.shape({
    headline: PropTypes$1.string,
    tags: PropTypes$1.arrayOf(PropTypes$1.shape({
      title: PropTypes$1.string,
      id: PropTypes$1.string,
      slug: PropTypes$1.string
    })).isRequired
  })).isRequired
};
TagTeaser.defaultProps = {
  className: '',
  headline: ''
};

export default TagTeaser;
